import React, { createContext, useState, useEffect, useContext } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const SocialMediaContext = createContext({
  socialMedia: null,
  loading: true,
});

export function useSocialMedia() {
  return useContext(SocialMediaContext);
}

export function SocialMediaProvider({ children }) {
  const [socialMedia, setSocialMedia] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'social_media_preferences', 'default'),
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          setSocialMedia({
            instagram: data.instagram || '',
            threads: data.threads || '',
            facebook: data.facebook || '',
            tiktok: data.tiktok || '',
            youtube: data.youtube || '',
            twitter: data.twitter || '',
            linkedin: data.linkedin || '',
            pinterest: data.pinterest || '',
          });
        } else {
          setSocialMedia(null);
        }
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching social media preferences:', error);
        setSocialMedia(null);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return (
    <SocialMediaContext.Provider value={{ socialMedia, loading }}>
      {children}
    </SocialMediaContext.Provider>
  );
}
